var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "extra-items": [{
        text: _vm.customer.name
      }]
    }
  })], 1)]), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-card', {
    staticClass: "mr-3 w-100 p-3"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row align-items-start"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('CustomerCard', {
    attrs: {
      "customer": _vm.customer,
      "show-unbind-button": _vm.customers.length > 0,
      "show-delete-button": _vm.showDeleteButton,
      "show-soft-delete-button": _vm.showSoftDeleteButton
    },
    on: {
      "trigger-fetch-customer": _vm.getCustomer,
      "trigger-init-data": _vm.loadInitialData
    }
  }), _c('b-card', {
    staticClass: "shadow-none rounded rounded-3 flex-fill mb-3"
  }, [_c('div', {
    staticClass: "\n                  wrapper\n                  d-flex\n                  align-items-center\n                  font-weight-medium\n                  text-muted\n                "
  }, [_c('i', {
    staticClass: "mdi mdi-crown mr-2",
    attrs: {
      "id": "icon-account-level-card-details-".concat(_vm.customer.id)
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "icon-account-level-card-details-".concat(_vm.customer.id),
      "placement": "left"
    }
  }, [_vm._v("會員等級")]), _vm.customer.loyalty ? _c('p', {
    staticClass: "mb-0 text-muted text-sm"
  }, [_vm._v(" " + _vm._s(_vm.customer.loyalty.level_name) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "\n                  wrapper\n                  d-flex\n                  align-items-center\n                  font-weight-medium\n                  text-muted\n                "
  }, [_c('i', {
    staticClass: "mdi mdi-calendar-range mr-2",
    attrs: {
      "id": "icon-account-level-card-expired-".concat(_vm.customer.id)
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "icon-account-level-card-expired-".concat(_vm.customer.id),
      "placement": "left"
    }
  }, [_vm._v("到期日")]), _vm.customer.loyalty ? _c('p', {
    staticClass: "mb-0 text-muted text-sm"
  }, [_vm.customer.loyalty.level_start_at && _vm.customer.loyalty.level_end_at ? [_vm._v(" " + _vm._s(_vm.customer.loyalty.level_start_at) + " ～ " + _vm._s(_vm.customer.loyalty.level_end_at) + " ")] : _vm.customer.loyalty.level_start_at && !_vm.customer.loyalty.level_end_at ? [_vm._v(" " + _vm._s(_vm.customer.loyalty.level_start_at) + " ～ 無期限 ")] : !_vm.customer.loyalty.level_start_at && _vm.customer.loyalty.level_end_at ? [_vm._v(" ～ " + _vm._s(_vm.customer.loyalty.level_end_at) + " ")] : _vm._e()], 2) : _vm._e()], 1)])], 1), _c('div', {
    staticClass: "flex-fill col-12 col-xl-6"
  }, [_vm._l(_vm.customers, function (i, idx) {
    return _c('div', {
      key: i.id,
      staticClass: "d-flex flex-row align-items-center"
    }, [_vm.showCustomers || idx == 0 ? [_c('i', {
      staticClass: "mdi mdi-link-variant mdi-rotate-45 mr-2 h3 text-secondary"
    }), _c('CustomerCard', {
      attrs: {
        "customer": i,
        "show-unbind-button": _vm.customers.length > 0,
        "show-underline": true
      },
      on: {
        "trigger-fetch-customer": _vm.getCustomer,
        "trigger-init-data": _vm.loadInitialData
      }
    })] : _vm._e()], 2);
  }), _vm.customers.length > 1 ? _c('b-button', {
    staticClass: "w-100 d-flex justify-content-between",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        _vm.showCustomers = !_vm.showCustomers;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.showCustomers ? '隱藏內容' : '展開更多') + " "), _c('i', {
    staticClass: "mdi",
    class: "mdi-chevron-double-".concat(_vm.showCustomers ? 'up' : 'down')
  })]) : _vm._e()], 2)]), _c('div', {
    staticClass: "mt-5"
  }, [_c('b-tabs', {
    on: {
      "input": _vm.handleTab
    },
    model: {
      value: _vm.activeTabIndex,
      callback: function callback($$v) {
        _vm.activeTabIndex = $$v;
      },
      expression: "activeTabIndex"
    }
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('b-tab', {
      key: index,
      attrs: {
        "title": tab.title
      }
    });
  }), 1), _vm.activeTabHash === '#tag' ? _c('div', [_c('div', {
    staticClass: "p-3"
  }, [!_vm.isEditTags ? _c('div', _vm._l(_vm.orderedTags, function (tag) {
    return _c('b-badge', {
      key: tag,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "variant": "dark"
      }
    }, [_vm._v(_vm._s(tag))]);
  }), 1) : _c('b-form-tags', {
    attrs: {
      "input-id": "tags",
      "placeholder": "輸入標籤",
      "size": "lg",
      "tag-variant": "dark",
      "remove-on-delete": "",
      "separator": " ,;",
      "addButtonText": "新增"
    },
    model: {
      value: _vm.tags,
      callback: function callback($$v) {
        _vm.tags = $$v;
      },
      expression: "tags"
    }
  }), _vm.checkPermission([_vm.consts.CUSTOMER_LIST_TAG_EDIT]) ? _c('div', {
    staticClass: "mt-3 text-center"
  }, [!_vm.isEditTags ? _c('b-button', {
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "inverse-warning"
    },
    on: {
      "click": function click($event) {
        _vm.isEditTags = true;
      }
    }
  }, [_vm._v(" 編輯標籤 ")]) : [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "inverse-info"
    },
    on: {
      "click": _vm.handleCancelTags
    }
  }, [_vm._v(" 取消 ")]), _c('b-button', {
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": _vm.handleSaveTags
    }
  }, [_vm._v(" 儲存 ")])]], 2) : _vm._e()], 1)]) : _vm._e(), _vm.activeTabHash === '#basic' ? _c('div', [_c('div', {
    staticClass: "p-3"
  }, [_c('div', [_vm._v("顯示名稱：" + _vm._s(_vm.customer.name))]), _c('div', [_vm._v("手機：" + _vm._s(_vm.customer.mobile_phone))]), _c('div', [_vm._v("Email：" + _vm._s(_vm.customer.email))]), _c('div', [_vm._v("生日：" + _vm._s(_vm.customer.birthday))]), _c('div', [_vm._v("性別：" + _vm._s(_vm.customer.sexual))]), _c('div', [_vm._v("好友：" + _vm._s(_vm.customer.is_friend ? "是" : "否"))]), _c('div', [_vm._v("識別編號：" + _vm._s(_vm.customer.outer_code))]), _c('div', [_vm._v("建立時間：" + _vm._s(_vm.customer.created_at))]), _c('div', [_vm._v("加入時間：" + _vm._s(_vm.customer.join_datetime))]), _vm.customer.leave_datetime ? _c('div', [_vm._v(" 離開時間：" + _vm._s(_vm.customer.leave_datetime) + " ")]) : _vm._e(), _c('div', [_vm._v("更新時間：" + _vm._s(_vm.customer.updated_at))]), _c('div', [_vm._v(" 手機是否驗證：" + _vm._s(_vm.customer.phone_verified ? "是" : "否") + " ")]), _c('div', [_vm._v("手機驗證時間：" + _vm._s(_vm.customer.phone_verified_at))]), _c('div', [_vm._v("註冊時間：" + _vm._s(_vm.customer.registered_at))]), _c('div', [_vm._v("條款接受時間：" + _vm._s(_vm.customer.accept_term_at))])])]) : _vm._e(), _vm.activeTabHash === '#detail' ? _c('div', [_c('div', {
    staticClass: "p-3"
  }, _vm._l(_vm.fields, function (field, index) {
    return _c('div', {
      key: 'field' + index
    }, [_vm._v(" " + _vm._s(field.title) + " : "), (_vm.customer.profiles[field.matched_key] || '').length > 30 ? _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-full-view",
        modifiers: {
          "modal-full-view": true
        }
      }],
      staticClass: "flex-shrink-0 mr-2",
      attrs: {
        "variant": ""
      },
      on: {
        "click": function click($event) {
          _vm.logForFullView = _vm.customer.profiles[field.matched_key] || '', _vm.logTitle = field.title;
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-arrow-expand-all"
    })]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("hiddenString")(_vm.customer.profiles[field.matched_key] || '', 30)) + " ")], 1);
  }), 0)]) : _vm._e(), _vm.activeTabHash === '#staff-bind-list' ? _c('div', [_c('customer-staff-list')], 1) : _vm._e(), _vm.activeTabHash === '#list-by-user-id' ? _c('div', [_c('CustomerListByUserID')], 1) : _vm._e(), _vm.activeTabHash === '#list-point-logs' ? _c('div', {
    staticClass: "p-3"
  }, [_c('PointLog', {
    attrs: {
      "showFilter": false,
      "excludeFields": ['customer_name', 'actions'],
      "upperCustomerId": _vm.$route.params.customerID,
      "upperMerchantId": _vm.customer.merchant.id
    }
  })], 1) : _vm._e(), _vm.activeTabHash === '#list-redeem-logs' ? _c('div', {
    staticClass: "p-3"
  }, [_c('RedeemLog', {
    attrs: {
      "showFilter": false,
      "includeFields": ['created_at', 'gift_name', 'gift_data', 'batch_total_points'],
      "upperMerchantId": _vm.customer.merchant.id,
      "upperCustomerId": _vm.$route.params.customerID
    }
  })], 1) : _vm._e(), _vm.activeTabHash === '#list-redeem-code-belonged' ? _c('div', {
    staticClass: "p-3"
  }, [_c('BelongedRedeemCode', {
    attrs: {
      "showFilter": false,
      "excludeFields": ['customer'],
      "upperCustomer": _vm.customer
    }
  })], 1) : _vm._e(), _vm.activeTabHash === '#list-orders' ? _c('div', {
    staticClass: "p-3"
  }, [_c('keep-alive', [_c('Order', {
    attrs: {
      "showFilter": false,
      "excludeFields": ['customer_name'],
      "upperCustomerId": _vm.$route.params.customerID,
      "with-related-orders": true
    }
  })], 1)], 1) : _vm._e(), _vm.activeTabHash === '#list-branches' ? _c('div', {
    staticClass: "p-3"
  }, [_c('BranchList', {
    attrs: {
      "showFilter": false,
      "includeFields": ['created_at', 'gift_name', 'gift_data', 'batch_total_points'],
      "upperMerchantId": _vm.customer.merchant.id,
      "upperCustomerId": _vm.$route.params.customerID
    }
  })], 1) : _vm._e(), _vm.activeTabHash === '#level-history' ? _c('div', {
    staticClass: "p-3"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.levelHistoryLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('h5', {
    staticClass: "mb-3"
  }, [_vm._v("等級變更紀錄")]), _vm.levelLogs.length > 0 ? _c('b-table', {
    attrs: {
      "items": _vm.levelLogs,
      "fields": _vm.levelLogFields,
      "striped": "",
      "hover": "",
      "small": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(level_name)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(data.value || '-'))])];
      }
    }, {
      key: "cell(period)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.start_at || '-') + " ~ " + _vm._s(data.item.end_at || '無期限') + " ")];
      }
    }], null, false, 2686476367)
  }) : _c('div', {
    staticClass: "text-muted text-center py-3"
  }, [_vm._v(" 尚無等級變更紀錄 ")])], 1), _c('div', [_c('h5', {
    staticClass: "mb-3"
  }, [_vm._v("等級計算紀錄")]), _vm.levelCalculations.length > 0 ? _c('b-table', {
    attrs: {
      "items": _vm.levelCalculations,
      "fields": _vm.levelCalculationFields,
      "striped": "",
      "hover": "",
      "small": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(calculation_type_name)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getCalculationTypeVariant(data.item.calculation_type)
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(level_change)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.before_level_name || '-') + " "), _c('i', {
          staticClass: "mdi mdi-arrow-right mx-1"
        }), _vm._v(" " + _vm._s(data.item.after_level_name || '-') + " ")];
      }
    }, {
      key: "cell(action_taken_name)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getActionTakenVariant(data.item.action_taken)
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(calculated_amount)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.value ? data.value.toLocaleString() : '-') + " ")];
      }
    }, {
      key: "cell(memo)",
      fn: function fn(data) {
        return [data.value ? _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-level-memo",
            modifiers: {
              "modal-level-memo": true
            }
          }],
          staticClass: "p-0",
          attrs: {
            "variant": "link",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              _vm.selectedMemo = data.value;
            }
          }
        }, [_vm._v(" 查看詳情 ")]) : _c('span', [_vm._v("-")])];
      }
    }], null, false, 449653447)
  }) : _c('div', {
    staticClass: "text-muted text-center py-3"
  }, [_vm._v(" 尚無等級計算紀錄 ")]), _vm.levelCalculationsMeta.last_page > 1 ? _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.levelCalculationsMeta.total,
      "per-page": _vm.levelCalculationsMeta.per_page
    },
    on: {
      "change": _vm.handleLevelCalculationsPageChange
    },
    model: {
      value: _vm.levelCalculationsPage,
      callback: function callback($$v) {
        _vm.levelCalculationsPage = $$v;
      },
      expression: "levelCalculationsPage"
    }
  })], 1) : _vm._e()], 1)])], 1) : _vm._e()], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-full-view",
      "title": _vm.logTitle
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('JsonEditor', {
    attrs: {
      "height": "400px"
    },
    model: {
      value: _vm.logForFullView,
      callback: function callback($$v) {
        _vm.logForFullView = $$v;
      },
      expression: "logForFullView"
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-level-memo",
      "title": "等級計算詳情",
      "size": "lg"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-secondary",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('pre', {
    staticClass: "level-memo-content"
  }, [_vm._v(_vm._s(_vm.selectedMemo))])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }